import './style.css'
import { KrawoomApp } from './app/krawoom-app'

const app = new KrawoomApp()

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('./service-worker.js')
  })
}

if (import.meta.hot) {
  import.meta.hot.dispose(() => app.destroy())
}
